module.exports = __webpack_public_path__ + "img/barIcon5.5d06b099.png";